import React from "react";

function StoreFilters({ onSelect = () => {}, filters }) {
  const data = [
    {
      label: "Jeddah Store",
      value: 1,
    },

    {
      label: "Riyadh Store",
      value: 3,
    },
    {
      label: "Riyadh Lab",
      value: 4,
    },
    {
      label: "Jeddah Lab",
      value: 2,
    },
  ];
  return (
    <div className=" flex justify-center items-center gap-2 mb-2 flex-wrap">
      {data?.map((dt) => (
        <div
          onClick={() => onSelect(dt?.value)}
          className={` px-4 py-2 bg-gray-100  cursor-pointer  rounded-md ${
            filters?.storeId == dt?.value
              ? "border border-primary text-primary"
              : ""
          }`}
        >
          {dt?.label}
        </div>
      ))}
    </div>
  );
}

export default StoreFilters;
